// extracted by mini-css-extract-plugin
module.exports = {"vin":"CarTitleAdmin-vin-3LYH8","action":"CarTitleAdmin-action-2h6FG"};